export const IS_TABBING_CLASS = 'user-is-tabbing';
